import React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from '@components/Avatar/Avatar';
import { WebModal } from '@components/Modals/WebModal';
import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import { PublicChat } from '@graphql/generated';
import theme from '@themes/theme';

type ChatGroupWelcomeModalProps = {
  chatInfo: PublicChat;
  visible: boolean;
  onClose: () => void;
  onAccept: () => void;
};

export const ChatGroupWelcomeModal: React.FC<ChatGroupWelcomeModalProps> = ({
  visible,
  onClose,
  onAccept,
  chatInfo,
}) => {
  const { t } = useTranslation('models');

  const { id: chatId, name, userCount, ownerName } = chatInfo || {};

  const button = (
    title: string,
    onPress: () => void,
    backgroundColor: keyof typeof theme.colors,
    titleColor: keyof typeof theme.colors,
    marginRight: keyof typeof theme.spacing = 'none'
  ) => (
    <Button
      width={244}
      height={48}
      marginRight={marginRight}
      isSmall={true}
      variant='edit'
      borderColor='black'
      borderRadius='xs'
      disabled={false}
      backgroundColor={backgroundColor}
      onPress={onPress}
      accessibilityLabel={title}>
      <Text variant='labelSmall' color={titleColor}>
        {title}
      </Text>
    </Button>
  );

  return (
    <WebModal
      accessibilityLabel='Chat Group Welcome Modal'
      onClose={onClose}
      visible={visible}
      width={600}
      height={322}>
      <Box m='l' p='l'>
        <Box flexDirection='row' justifyContent='center'>
          <Avatar
            size='large64'
            id={chatId}
            // avatarType='User'
            isMultiple={true}
            disableAvatarPress={true}
            label={name ?? null}
          />
        </Box>
        <Text
          mt='xs'
          variant='heading2'
          numberOfLines={1}
          ellipsizeMode='tail'
          // flexShrink={1}
          color='textPrimary'
          textAlign='center'>
          {name ?? 'group chat'}
        </Text>
        <Text mt='xs' variant='body' color='textSecondary' textAlign='center'>
          {t('models:chat.membersCreatedBy', {
            memberCount: userCount,
            owner: ownerName,
          })}
        </Text>
        <Box flexDirection='row' mt='xl'>
          {button(t('shared:notNow'), onClose, 'white', 'black', 'm')}
          {button(t('chat.acceptAndJoin'), onAccept, 'black', 'white')}
        </Box>
      </Box>
    </WebModal>
  );
};
